module.exports = __webpack_public_path__ + "img/gavT.1edda662.jpeg";